import { render, staticRenderFns } from "./Sku.vue?vue&type=template&id=6906c06c&scoped=true&"
import script from "./Sku.vue?vue&type=script&lang=js&"
export * from "./Sku.vue?vue&type=script&lang=js&"
import style0 from "./Sku.vue?vue&type=style&index=0&id=6906c06c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6906c06c",
  null
  
)

export default component.exports